var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconGradient = function SvgIconGradient(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 5.375a1 1 0 0 0 0 2h18a1 1 0 1 0 0-2zM3 9.125a1 1 0 0 0 0 2h7.125a1 1 0 1 0 0-2zM13.875 9.125a1 1 0 1 0 0 2H21a1 1 0 1 0 0-2zM2 13.875a1 1 0 0 1 1-1h3.375a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1M17.625 12.875a1 1 0 1 0 0 2H21a1 1 0 1 0 0-2zM9.125 13.875a1 1 0 0 1 1-1h3.75a1 1 0 1 1 0 2h-3.75a1 1 0 0 1-1-1M3 16.625a1 1 0 1 0 0 2h1.875a1 1 0 1 0 0-2zM7.625 17.625a1 1 0 0 1 1-1h1.5a1 1 0 1 1 0 2h-1.5a1 1 0 0 1-1-1M13.875 16.625a1 1 0 1 0 0 2h1.5a1 1 0 1 0 0-2zM18.125 17.625a1 1 0 0 1 1-1H21a1 1 0 1 1 0 2h-1.875a1 1 0 0 1-1-1"
  }))));
};
export default SvgIconGradient;